import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import './assets/styles/tailwind.css'; // Import your Tailwind CSS file
import { FontAwesomeIcon } from './fontawesome';
import scrollFade from './directives/scrollFade';
import staggerFade from './directives/staggerFade';

const app = createApp(App);

// Register global components
app.component('font-awesome-icon', FontAwesomeIcon);

// Use plugins
app.use(router);

//Custom directives
app.directive('scroll-fade',scrollFade);
app.directive('stagger-fade',staggerFade);

// Mount the app
app.mount('#app');